<template>
  <h1 class="text-center">Contents</h1>
</template>

<script>
export default {
  name: "Contents"
}
</script>

<style scoped>

</style>